'use client';

import { useEffect } from 'react';
import { useCheckout } from './checkout-context';
import PlanStep from './steps/plan-step';
import AuthStep from './steps/auth-step';
import PaymentStep from './steps/payment-step';
import SuccessStep from './steps/success-step';
import LoadingStep from './steps/loading-step';

export default function CheckoutContent() {
  const { state, isEmbedded, modalWidthClass, handleClose } = useCheckout();

  // Set transparent body background for embedded mode
  useEffect(() => {
    if (!isEmbedded) return;

    document.body.style.backgroundColor = 'transparent';

    return () => {
      document.body.style.backgroundColor = '';
    };
  }, [isEmbedded]);

  const containerClass = isEmbedded
    ? 'min-h-screen flex items-center justify-center bg-black/80 p-4'
    : '';

  // Width class for the content - uses modalWidthClass for dynamic sizing
  // In embedded mode, some screens have different (or no) background treatments (eg. 'loading' none, 'plan' blue, others white)
  const embedNeedsBackground = state.step !== 'loading';
  const embedBackgroundColor = state.step === 'plan' ? 'bg-blue-50' : 'bg-white';
  const contentClass = isEmbedded
    ? `${embedNeedsBackground ? embedBackgroundColor + ' shadow-xl' : ''} ${modalWidthClass} w-full max-h-[90vh] overflow-y-auto`
    : `bg-white ${modalWidthClass} w-full transition-all duration-200`;

  return (
    <div className={containerClass}>
      <div className={contentClass}>
        {/* Close button - hidden during loading */}
        {state.step !== 'loading' && (
          <div className="flex justify-end p-4 pb-0">
            <button
              onClick={handleClose}
              className="text-slate-400 hover:text-slate-600 transition-colors"
              aria-label="Close"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        )}

        {/* Step content */}
        <div className="px-6 pb-6">
          {state.step === 'loading' && <LoadingStep />}
          {state.step === 'plan' && <PlanStep />}
          {state.step === 'auth' && <AuthStep />}
          {state.step === 'payment' && <PaymentStep />}
          {state.step === 'success' && <SuccessStep />}
        </div>
      </div>
    </div>
  );
}
